import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Input, { Select } from "../../containers/InputForm";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { NewStationEdit } from "../../../server/Station";

const schema = yup
  .object({
    name: yup.string().required("שדה חובה"),
    address: yup.string().required("שדה חובה"),
    type: yup.string().required("שדה חובה"),
    status: yup.string().required("שדה חובה"),
  })
  .required();

const Station = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      address: "",
      type: "warehouse",
      status: "active",
    },
  });

  const editNewStation = (data) => {
    console.log("Sending data:", data);
    NewStationEdit(data)
      .then((x) => {
        console.log("New station added:", x.data);
        reset();
      })
      .catch((error) => {
        console.log("error:", error);
      });
  };

  return (
    <div className="add-station">
      <h1 className="title-role">הוספת מחסן ל-db החדש</h1>
      <form onSubmit={handleSubmit(editNewStation)}>
        <h3>פרטי תחנה</h3>
        <div className="row">
          <div className="field-wrapper">
            <Input
              errors={errors}
              label="שם"
              name="name"
              type="text"
              register={register}
            />
          </div>
          <div className="field-wrapper">
            <Input
              errors={errors}
              label="כתובת"
              name="address"
              type="text"
              register={register}
            />
          </div>
          <div className="field-wrapper">
            <Select
              errors={errors}
              label="סוג"
              name="type"
              options={[
                { Name: "Warehouse", Id: "warehouse" },
                { Name: "Station", Id: "station" },
              ]}
              {...register("type")}
            />
          </div>
          <div className="field-wrapper">
            <Select
              errors={errors}
              label="סטטוס"
              name="status"
              options={[
                { Name: "פעיל", Id: "active" },
                { Name: "לא פעיל", Id: "inactive" },
              ]}
              {...register("status")}
            />
          </div>
          <button className="btn" type="submit">
            הוסף
          </button>
        </div>
      </form>
    </div>
  );
};

export default Station;
